export const DEFAULT_SEARCH_SETTINGS = {
  defaultOccupants: {
    adults: 2,
    children: 0,
    childrenAge: [],
    childrenBirthDate: [],
    infants: 0,
  },
  mapView: {
    pinLimit: 20,
    additionalPins: 10,
  },
}

interface MapViewSettings {
  pinLimit: number
  additionalPins: number
}

export function getMapSearchPageSize(
  isGeographicDiversityTreatment: boolean,
  mapView: MapViewSettings = DEFAULT_SEARCH_SETTINGS.mapView,
): number {
  const controlPageSize = mapView.pinLimit ?? 20

  if (!isGeographicDiversityTreatment) {
    return controlPageSize
  }

  return mapView.pinLimit + mapView.additionalPins
}

export function getMapSearchMarkerCap(
  pageSize: number,
  mapView: MapViewSettings = DEFAULT_SEARCH_SETTINGS.mapView,
): number {
  return pageSize + mapView.additionalPins
}
